"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SVGInfo = void 0;
class SVGInfo {
    _ID;
    _Bbox;
    _SVG;
    constructor(id, measurements, svg) {
        this._ID = id;
        this._Bbox = measurements;
        this._SVG = svg;
    }
    getID() {
        return this._ID;
    }
    getBbox() {
        return this._Bbox;
    }
    getSVG() {
        return this._SVG;
    }
    toString() {
        return this._ID + "\n" + this._Bbox.toString() + "\n" + this._SVG;
    }
}
exports.SVGInfo = SVGInfo;
//# sourceMappingURL=SVGInfo.js.map